import { Chip } from '@mui/material';

export function ConfigPedidoSituacaoColumn({ idStatus }: { idStatus: number }) {
    let color: 'error' | 'success';
    let title: string;

    if (idStatus === 2) {
        color = 'success';
        title = 'Completo';
    } else {
        color = 'error';
        title = 'Incompleto';
    }

    return <Chip label={title} variant="outlined" size="small" color={color} sx={{ width: '100%' }} />;
}
